/**
 * Toast notification configuration
 * Customize duration, position, and other toast behavior here
 */

export const toastConfig = {
    // Display durations per variant (in milliseconds)
    duration: {
        success: 3000,  // Quick confirmation
        error: 6000,    // Longer for errors - users need time to read
        warning: 5000,  // Medium duration for warnings
        info: 3000,     // Standard duration for info
        default: 3000,  // Fallback duration
    },

    // Snackbar layout
    anchorOrigin: {
        vertical: 'top' as const,
        horizontal: 'right' as const,
    },

    // Maximum number of concurrent toasts
    maxSnacks: 3,
};
